import React, { useEffect, useState, useRef } from 'react';
import { dashAPI, productAPI, orderAPI, returnAPI, walletAPI, dealAPI, profileAPI, notifAPI } from './SellerApi';


export const SellerWallet = () => {
  const [balance, setBalance]  = useState(null);
  const [txns,    setTxns]     = useState([]);
  const [bank,    setBank]     = useState(null);
  const [amount,  setAmount]   = useState('');
  const [loading, setLoading]  = useState(true);
  const [saving,  setSaving]   = useState(false);
  const [bankEdit,setBankEdit] = useState(false);
  const [bankForm,setBankForm] = useState({ account_holder:'', bank_name:'', account_number:'', ifsc:'', upi_id:'' });
  const [success, setSuccess]  = useState('');
  const [error,   setError]    = useState('');

  useEffect(() => {
    Promise.all([walletAPI.balance(), walletAPI.transactions(), walletAPI.bankDetails()])
      .then(([b,t,bk]) => { setBalance(b.data); setTxns(t.data||[]); setBank(bk.data); if(bk.data) setBankForm(bk.data); })
      .catch(() => {
        setBalance({ available:8400, pending:2200 });
        setTxns([
          { id:1, type:'credit', description:'Order #ATR-9918 commission', amount:50,  created_at:'2026-04-12' },
          { id:2, type:'credit', description:'Order #ATR-9920 commission', amount:160, created_at:'2026-04-13' },
          { id:3, type:'debit',  description:'Withdrawal to bank',          amount:500, created_at:'2026-04-10' },
        ]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleWithdraw = async () => {
    const amt = parseFloat(amount);
    if (!amt || amt < 100) { setError('Minimum withdrawal ₹100'); return; }
    if (amt > (balance?.available||0)) { setError('Insufficient balance'); return; }
    setSaving(true); setError('');
    try {
      await walletAPI.withdraw(amt);
      setSuccess(`₹${amt} withdrawal requested! Credited in 2 business days.`);
      setAmount('');
      const b = await walletAPI.balance(); setBalance(b.data);
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  const handleSaveBank = async () => {
    setSaving(true); setError('');
    try {
      await walletAPI.saveBank(bankForm);
      setBank(bankForm); setBankEdit(false);
      setSuccess('Bank details saved!');
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  return (
    <div>
      {error   && <div className="sp-error">{error}</div>}
      {success  && <div className="sp-success">{success}</div>}

      <div className="sp-wallet-hero">
        <div>
          <div className="sp-wallet-label">AVAILABLE BALANCE</div>
          <div className="sp-wallet-amount">{loading ? '—' : `₹${Number(balance?.available||0).toLocaleString('en-IN')}`}</div>
          <div className="sp-wallet-pending">Pending: <span>₹{Number(balance?.pending||0).toLocaleString('en-IN')}</span></div>
        </div>
        <div className="sp-withdraw-form">
          <input className="sp-withdraw-input" type="number" placeholder="Amount to withdraw" value={amount} onChange={e => setAmount(e.target.value)} min={100} />
          <button className="sp-withdraw-btn" onClick={handleWithdraw} disabled={saving}>{saving ? 'Processing…' : 'Withdraw →'}</button>
        </div>
      </div>

      <div className="sp-wallet-grid">
        <div className="sp-card">
          <div className="sp-card-title">Transaction History</div>
          {txns.map(t => (
            <div key={t.id} className="sp-txn-item">
              <div className={`sp-txn-icon ${t.type}`}>{t.type==='credit'?'↙':'↗'}</div>
              <div style={{flex:1}}>
                <div className="sp-txn-desc">{t.description}</div>
                <div className="sp-txn-date">{new Date(t.created_at).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}</div>
              </div>
              <div className={`sp-txn-amt ${t.type}`}>{t.type==='credit'?'+':'−'}₹{Number(t.amount).toLocaleString('en-IN')}</div>
            </div>
          ))}
          {txns.length === 0 && <p style={{color:'var(--t3)',fontSize:13,textAlign:'center',padding:'1.5rem'}}>No transactions yet</p>}
        </div>

        <div className="sp-card">
          <div className="sp-card-title">
            Bank Account
            <button style={{fontSize:12,color:'var(--em-400)',background:'none',cursor:'pointer',fontFamily:'var(--fb)'}} onClick={() => setBankEdit(e => !e)}>
              {bankEdit ? 'Cancel' : 'Edit'}
            </button>
          </div>
          {bankEdit ? (
            <div>
              {[['account_holder','Account Holder Name','text'],['bank_name','Bank Name','text'],['account_number','Account Number','text'],['ifsc','IFSC Code','text'],['upi_id','UPI ID (optional)','text']].map(([k,l,t]) => (
                <div key={k} className="sp-input-group">
                  <label className="sp-label">{l.toUpperCase()}</label>
                  <input className="sp-input" type={t} value={bankForm[k]||''} onChange={e => setBankForm(b => ({...b,[k]:e.target.value}))} />
                </div>
              ))}
              <button className="sp-btn-primary" onClick={handleSaveBank} disabled={saving}>{saving?'Saving…':'Save Bank Details'}</button>
            </div>
          ) : bank ? (
            <div>
              {[['Account Holder',bank.account_holder],['Bank',bank.bank_name],['Account No.',`**** **** ${bank.account_number?.slice(-4)}`],['IFSC',bank.ifsc]].map(([l,v]) => (
                <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'0.65rem 0',borderBottom:'1px solid var(--border)'}}>
                  <span style={{fontSize:12,color:'var(--t3)'}}>{l}</span>
                  <span style={{fontSize:13.5,fontWeight:600,color:'var(--t1)',fontFamily:'var(--fd)'}}>{v||'—'}</span>
                </div>
              ))}
              <button className="sp-btn-secondary" style={{width:'100%',marginTop:'1rem'}} onClick={() => setBankEdit(true)}>Update Bank Details</button>
            </div>
          ) : (
            <div style={{textAlign:'center',padding:'1.5rem'}}>
              <p style={{color:'var(--t3)',fontSize:13,marginBottom:'1rem'}}>No bank account added yet.</p>
              <button className="sp-btn-primary" onClick={() => setBankEdit(true)}>Add Bank Account</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SellerWallet;